export default "__VITE_ASSET__V7xujLhF__"